import { Link } from "@tanstack/react-router";
import { Badge } from "./ui/badge";
import { ChevronRight } from "lucide-react";
import { TeaserImage } from "./TeaserImage";
import { RichTextRenderer } from "~/components/RichTextRenderer";

export const TeaserStacked = ({
  eyebrow,
  tag,
  title,
  description,
  readMoreLabel,
  image,
  link,
}: {
  eyebrow: string;
  tag?: string;
  title: string;
  description: string;
  readMoreLabel?: string;
  image: string;
  link: string;
}) => {
  return (
    <Link to={link}>
      <TeaserImage image={image} alt="" width={778} height={435} />
      <div className="mt-6 flex items-center gap-4">
        <Badge variant={"outline"}>{tag}</Badge>
        <p className="text-sm font-semibold">{eyebrow}</p>
      </div>
      <h2 className="mt-6 text-2xl font-medium">{title}</h2>
      <RichTextRenderer
        additionalClasses="text-base mt-2"
        richText={description}
      />

      {readMoreLabel && (
        <span className="mt-4 flex items-center gap-1">
          {readMoreLabel} <ChevronRight className="size-5" />
        </span>
      )}
    </Link>
  );
};
